import type { FC, PropsWithChildren } from 'react';

import { Modal } from '../../ui/modal';

export type AuthModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  persistent?: boolean;
};

export const AuthModal: FC<PropsWithChildren<AuthModalProps>> = ({
  children,
  open,
  setOpen,
  persistent = false,
}) => {
  return (
    <Modal
      open={open}
      onOpenChange={setOpen}
      width={400}
      minHeight={500}
      persistent={persistent}
      withoutCloseButton={persistent}
      contentOptions={{
        ['data-testid' as string]: 'auth-modal',
        style: { padding: '44px 40px 0' },
      }}
      overlayOptions={
        persistent
          ? {
              style: {
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
              },
            }
          : undefined
      }
    >
      {children}
    </Modal>
  );
};
